// Lessons, TrueChops's official extension for private teachers: a list of students, each one's lessons,
// and what happens between them. Built on the platform like School (plugins/school).
import dynamic from "next/dynamic";
import { createElement as h } from "react";

const Home = dynamic(() => import("./LessonsHome"), { ssr: false });
const StudentPage = dynamic(() => import("./StudentPage"), { ssr: false });
const LessonEditor = dynamic(() => import("./LessonEditor"), { ssr: false });
const LessonPage = dynamic(() => import("./LessonPage"), { ssr: false });
const PathEditor = dynamic(() => import("./PathEditor"), { ssr: false });
const Join = dynamic(() => import("./Join"), { ssr: false });
const AssignButton = dynamic(() => import("../../src/components/teaching/AssignButton"), { ssr: false });

const lessons = {
  id: "lessons",
  name: "Lessons",
  official: true,
  setup(api) {
    api.page("/", Home, { title: "Lessons" });
    api.page("/join/:code", Join, { title: "Join your teacher" });
    api.page("/s/:id", StudentPage, { title: "Student" });
    api.page("/s/:id/new", LessonEditor, { title: "New lesson" });
    api.page("/l/:id", LessonPage, { title: "Lesson" });
    api.page("/l/:id/edit", LessonEditor, { title: "Edit lesson", props: { editing: true } });
    api.page("/p/new", PathEditor, { title: "New path" });
    api.page("/p/:id", PathEditor, { title: "Path" });
    api.filter("nav.places", (places) => api.installed() ? places.map((place) => place.id === "play" ? { ...place, tabs: [...place.tabs, { id: "lessons", label: "Lessons", href: "/lessons", app: "lessons" }] } : place) : places);
    api.slot("score.toolbar.end", () => api.installed() ? h(AssignButton, { to: "/lessons", label: "Add to a lesson" }) : null);
  },
};
export default lessons;
